import React, {useEffect} from 'react';
import {LiveInfo} from "../../../../@shared/apis/wowPartner";
import {wowPartnerApi} from "../../../../@shared/apis";

const YoutubeLiveInfo = () => {
  const [liveInfo, setLiveInfo] = React.useState<LiveInfo | null>(null)

  useEffect(() => {
    wowPartnerApi.getLiveInfo().then((res) => {
      setLiveInfo(res.data)
    })

    // temp
    setLiveInfo({
      videoID: "NJUjU9ALj4A",
      title: "[TEST] 한국경제TV 24시간 -본 방송",
      programName: "성공투자 오후증시 2부",
      programUrl:
        "https://www.wowtv.co.kr/Broad/ProgramMain/Index?programCode=P3431",
      description:
        "-신속한 경제·증권 소식과 전문가의 분석·진단을 무료로 시청하세요 #SNS_채널은_모두 @hkwowtv",
      startTime: "15:00",
      endTime: "16:00",
    })
  }, [])

  if (!liveInfo) return null

  return (
    <div className="liveInfo">
      <div className="liveTitle">
        <div className="live">
          LIVE <div className="liveDot" />
        </div>
        {liveInfo?.title}
      </div>
      <div className="programName">
        {liveInfo?.programName}
        {liveInfo?.startTime &&
          liveInfo?.endTime &&
          `${liveInfo?.startTime} ~ ${liveInfo?.endTime}`}
      </div>
      <div className="description">{liveInfo?.description}</div>
    </div>
  )
}

export default YoutubeLiveInfo;